export function hasRecordValue(record, key) {
    return Boolean(record && Object.prototype.hasOwnProperty.call(record, key));
}

export function withRecordValue(record, key, value) {
    const source = record || {};
    if (hasRecordValue(source, key) && source[key] === value) {
        return source;
    }
    return { ...source, [key]: value };
}

export function withoutRecordValue(record, key) {
    if (!record || !Object.prototype.hasOwnProperty.call(record, key)) {
        return record || {};
    }

    const nextRecord = { ...record };
    delete nextRecord[key];
    return nextRecord;
}
